import apolloClient from 'utils/apolloClient';
import { ApolloProvider } from '@apollo/client';
import Content from './Content';

// TODO: is this file necessary?

function App() {

  return (
    <ApolloProvider client={apolloClient}>
      <Content/>
    </ApolloProvider>
  )
}

export default App;
